<template>
  <div>
    <vs-popup id="add_promo_discount__modal" title="Add Promo Discount" :active.sync="isActive">
      <form>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <!-- discount name -->
            <div class="mb-2 w-full">
              <label for="discountName">Discount Name</label>
              <vs-input v-model="form.discount_name" class="w-full mb-1" name="Discount Name" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Discount Name')">{{ errors.first('Discount Name') }}</span>
            </div>

            <!-- discount status -->
            <div class="mb-2 w-full">
              <label for="discountStatus">Discount Status</label>
              <vs-switch color="primary" v-model="form.discount_status">
                <span slot="on">Active</span>
                <span slot="off">Inactive</span>
              </vs-switch>
            </div>

            <!-- discount on -->
            <div class="mb-2 w-full">
              <label for="discountOn">Discount On</label>
              <select-2
                id="discountOn"
                class="w-full mb-1"
                :value="form.discount_on"
                @input="
                  item => {
                    this.form.discount_on = item && item.value
                  }
                "
                name="Discount On"
                placeholder="Select Discount On"
                autocomplete
                :options="discountOnOptions"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Discount On')">{{ errors.first('Discount On') }}</span>
            </div>

            <!-- discount amount -->
            <div class="mb-2 w-full">
              <label for="discount">Discount</label>
              <vs-input type="number" v-model.number="form.discount_amount" class="w-full mb-1" name="Discount" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Discount')">{{ errors.first('Discount') }}</span>
            </div>

            <!-- discount type -->
            <div class="mb-2 w-full">
              <label for="discountType">Discount Type</label>
              <select-2
                id="discountType"
                class="w-full mb-1"
                :value="form.discount_type"
                @input="
                  item => {
                    this.form.discount_type = item && item.value
                  }
                "
                name="Discount Type"
                placeholder="Select Discount Type"
                autocomplete
                :options="discountTypeOptions"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Discount Type')">{{ errors.first('Discount Type') }}</span>
            </div>

            <!-- discount apply when -->
            <div class="mb-2 w-full">
              <label for="discountApplyWhen">Discount Apply When</label>
              <select-2
                id="discountApplyWhen"
                class="w-full mb-1"
                :value="form.discount_apply_when"
                @input="
                  item => {
                    this.form.discount_apply_when = item && item.value
                  }
                "
                name="Discount Apply When"
                placeholder="Select Discount Apply When"
                autocomplete
                :options="discountApplyWhenOptions"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Discount Apply When')">{{ errors.first('Discount Apply When') }}</span>
            </div>

            <div class="flex" v-if="form.discount_apply_when === discountApplyWhen.dateTime.replaceAll(' ', '')">
              <!-- start time -->
              <div class="mb-2 w-full">
                <label for="discountStartTime">Discount Start Time</label>
                <flat-pickr v-model="form.startTime" name="Discount Start Time" class="w-full" :config="config" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('Discount Start Time')">{{ errors.first('Discount Start Time') }}</span>
              </div>

              <!-- end time -->
              <div class="mb-2 ml-5 w-full">
                <label for="discountEndTime">Discount End Time</label>
                <flat-pickr v-model="form.endTime" name="Discount End Time" class="w-full" :config="config" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('Discount End Time')">{{ errors.first('Discount End Time') }}</span>
              </div>
            </div>

            <!-- week ok days -->
            <div class="mb-2 w-full" v-if="form.discount_apply_when === discountApplyWhen.dayOfWeek.replaceAll(' ', '')">
              <label for="weekOfDay">Week Of Days</label>
              <select-2
                :multiple="true"
                id="weekOfDay"
                class="w-full mb-1"
                :value="form.WeekOfDay"
                @input="
                  item => {
                    this.form.WeekOfDay = item && item.value
                  }
                "
                name="Week Of Days"
                placeholder="Select Week Days"
                autocomplete
                :options="weekDaysOptions"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Week Of Days')">{{ errors.first('Week Of Days') }}</span>
            </div>

            <!-- discount applicable customer -->
            <div class="mb-2 w-full">
              <label for="discountApplicableCustomers">Discount Applicable Cutomers</label>
              <select-2
                :multiple="true"
                id="discountApplicableCustomers"
                class="w-full mb-1"
                :value="form.customerIds"
                @input="
                  item => {
                    this.form.customerIds = item && item.value
                  }
                "
                name="Discount Applicable Customers"
                placeholder="Select Customers"
                autocomplete
                label="first_name"
                :ssr="true"
                action="patient/getPatients"
              />
            </div>
          </div>
        </div>

        <div class="vx-row mt-6 px-5 flex justify-end">
          <div>
            <vs-button class="mr-2" color="danger" type="relief" @click="isActive = false">Cancel</vs-button>
            <vs-button color="primary" type="relief" @click="createPromoDiscount" :disabled="!validateForm">Create Promo Discount</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { discountRule, discountType, discountApplyWhen } from '@/utils/enums'
import { RETAILER } from '@/utils/roles'

export default {
  name: 'AddPromoDiscountModal',
  components: {
    Select2,
    FlatPickr
  },

  props: {
    isModalShow: Boolean
  },

  data() {
    return {
      discountApplyWhen,
      discountOnOptions: Object.values(discountRule).map(x => {
        return {
          label: x,
          value: x
        }
      }),
      discountTypeOptions: Object.values(discountType).map(x => {
        const label = x.charAt(0).toUpperCase() + x.slice(1)
        return {
          label,
          value: label
        }
      }),
      discountApplyWhenOptions: Object.values(discountApplyWhen).map(x => {
        return {
          label: x,
          value: x.replaceAll(' ', '')
        }
      }),
      weekDaysOptions: moment.weekdays().map(x => {
        return {
          label: x,
          value: x
        }
      }),
      config: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i'
      },
      form: {
        discount_name: null,
        discount_status: false,
        discount_on: null,
        discount_amount: null,
        discount_type: null,
        discount_apply_when: null,
        startTime: null,
        endTime: null,
        WeekOfDay: [],
        customerIds: [],
        customer_type: null
      }
    }
  },

  computed: {
    ...mapState('auth', ['parentUser']),

    // close the poup
    isActive: {
      get() {
        return this.isModalShow
      },
      set(val) {
        this.$emit('update:isModalShow', val)
      }
    },

    // validate form
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    async createPromoDiscount() {
      if (!(await this.$validator.validate())) {
        return false
      }

      if (this.form.customerIds.length) {
        this.form.customer_type = RETAILER === this.parentUser.roleId ? 'patient' : 'client'
      }

      this.$store
        .dispatch('promo_discount/addPromoDiscount', this.form)
        .then(({ message }) => {
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.$emit('done')
          this.isActive = false
        })
        .catch(({ message }) => {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>

<style lang="scss">
#add_promo_discount__modal {
  .vs-popup {
    width: calc(100% - 50%) !important;
    position: relative;

    .con-vs-loading {
      position: absolute;
    }
  }
}
</style>
